export default "__VITE_ASSET__5a7c8d67__"